<template>
  <div id="foot">
    <div class="foot-t con">
        <span>{{$t('friendlink')}}：</span>   
        <ul>
          <li v-for="(item, index) in Friend" :key="index"> <a :href="item.Address">{{item.Link}}</a> </li>
        </ul>
    </div>
     <hr class="con">

    <div class="foot-m con">
        <ul>
          <li >{{$t('address')}}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{Contact.Address}}</li>
           <li>{{$t('tel')}}： {{Contact.PhoneNumber}}</li>
        </ul>
        
    </div> 
      <p data-v-520bf595="" class="con"><span>Copyright © www.xzzzqdermyy.com All rights reserved 版权所有</span>
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <span style="color:#939393;margin-left:20px"> 藏ICP备20000122号-1</span></a></p>
      <div style="width:300px;margin:0 auto; padding:0 0 20px 0;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=54010202000262"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../image/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">藏公网安备 54010202000262号</p>
        </a>
      </div>
  </div>
</template>

<script>
import {getFriend, getContact} from '@/api/api'
export default {
  data () {
    return {
      Friend: [],
      Lang: sessionStorage.getItem('lang'),
      Contact: {}
    }
  },
  methods: {
    async GetData (lang) {
      let res = await getFriend(lang)
      let {Head,Content} = res.data
      if (Head.Ret == 0) {
        this.Friend = Content.Items
      }
    },
    async getContact (lang) {
      let res = await getContact(lang)
      let {Head,Content} = res.data
      if (Head.Ret == 0) {
        this.Contact = Content.Item[0]
      }
    }
  },
  updated () {
    this.Lang = sessionStorage.getItem('lang')
  },
  watch: {
    'Lang': function(lang) {
      // history.go(0)
      this.GetData(lang)
      this.getContact(lang)
    }
  },
  created() {
    this.GetData(this.Lang)
    this.getContact(this.Lang)
  }
}
</script>


<style scoped lang="scss">
//底部
    #foot{
        width:100%;
        background: #3A3A3A;
        color: #b2b2b2;
       .foot-t {
         //width: 1230px;
         margin: 0 auto;
         font-size: 12px;
         //height: 100px;
         background: #3A3A3A;
         line-height: 1.5;
         padding-top: 40px;
         padding-bottom: 15px;
         span {
           float: left;
         }
         ul {
           //border: 1px solid red;
           margin-left: 60px;
           li {
             float: left;
             padding: 0 20px;
             border-right: 1px solid #b2b2b2;
             margin-bottom: 10px;
            
             &:last-child {
               border-right: none;
             }
             a {
               color: #b2b2b2;
               &:hover {
                 text-decoration: underline;
               }
             }
           }
           &:after {
             content: '';
             display: table;
             clear: both;
           };
         }
       }
       .foot-m {
         margin: 0 auto;
         font-size: 12px;
         line-height: 2;
         padding-top: 20px;
         clear: both;
         background: #3A3A3A;
       }
        p {
        line-height: 4;
        font-size: 12px;
        text-align: center;
        background: #3A3A3A;
      }  
        
    }

  hr {
    border: none;
    height: 0.5px;
    background: #999;
    color: #999;
  }


@media (max-width: 768px) {
  #foot {
    width: 96% !important;
    padding: 0 2%;
    // .foot-m {
    //   // text-align: center;
    // }
    .foot-t {
      li {
        border-right: none !important;
      }
    }
    p {
      margin: 0.2rem 0 0!important;
      line-height: 2 !important;
      float:none;
    }
  } 
}


</style>



// WEBPACK FOOTER //
// src/components/Foot.vue